import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, TextField } from '@material-ui/core';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import _ from 'lodash';
import clsx from 'clsx';
import {
  labelerTableHead,
  manufacturersTableHead,
  NDCTableHead,
} from './ExTableHead';
import {
  getRandomNumberByInput,
  handleExistingCommentList,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import DisplayErrorMessages from '../../../../../SharedModules/Errors/ErrorMessages';

import {
  NDC_ATLEAST_SELECT_ONE,
  ERRORMESSAGE_MFR_NOT_EMPTY,
  NDC_NOT_FOUND,
  NDC_NOT_FOUND_STC,
  REBATE_SELECT,
  ERR_NDC_NAME,
  ERR_NDC_NDC,
  NDC_CODE_FOR_STC_NOT,
  NDC_ALREADY_FOR_STC_NOT,
} from '../../../../../SharedModules/Errors/constantMessageData';
import GridTableComponent from './ExTableGrid';
import {
  getAllManufacturerList,
  getAllLabelerList,
  saveExcludedNDCsSearch,
  getNDCsListSearchByNameorNDCs,
  getNDCsListSearchByNLabeler,
  saveExcludedNDCsDetailList,
  saveExcludedNDCsSearchTable,
  saveExcludedNDCsTableList,
  saveExcludedNDCsErrorMsgList,
  excludedNDCsModalSearchTableList,
  setExNDCsExtraState,
  getExistingLabelerList,
  dispatchExcludedNDCsSearch,
} from '../../store/actions';

function ExcludedNDCsListGrid(props) {
  const { filterValue, pageFor, viewFilter, setLoading } = props;

  const dispatch = useDispatch();
  const getNDCsSearchList = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.drugsList
  );
  const getNDCsModalList = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.drugsModalList
  );
  const getManufacturerList = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.allManufacturer
  );
  const getLabelerList = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.allLabeler
  );
  const getSearchValue = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.searchValue
  );
  const getSearchValueTable = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.searchTable
  );
  const getNDCsTableListRedux = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.ndcsList
  );
  const getNDCsModalTableList = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.ndcsListForModal
  );
  const errorMessages = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.errorMessages
  );
  const extraState = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.extraState
  );
  const callLebelerAPI = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.extraState.callLebelerAPI
  );
  const clearNDCLeft = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.extraState.clearNDCLeft
  );
  const ndcInputErr = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.extraState.ndcInputErr
  );
  const searchPageErrMsg = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.errorMessages.serachPage
  );
  const getOriginalExistingNDCList = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer?.existingNDCOriginalList
  );

  const searchNDCsByNameOrNdcs = (value, data = []) =>
    dispatch(getNDCsListSearchByNameorNDCs(value, data));
  const searchNDCsByLabeler = (value, data = []) =>
    dispatch(getNDCsListSearchByNLabeler(value, data));
  const fetchAllManufacturerList = (value) =>
    dispatch(getAllManufacturerList(value));
  const fetchAllLabelerList = (value) => dispatch(getAllLabelerList(value));
  const setFilterValueAction = (value) =>
    dispatch(saveExcludedNDCsSearch(value));
  const setFilterValueTableAction = (value) =>
    dispatch(saveExcludedNDCsSearchTable(value));
  const setNDCsTableListAction = (value) =>
    dispatch(saveExcludedNDCsTableList(value));
  const setErrorMessages = (value) =>
    dispatch(saveExcludedNDCsErrorMsgList(value));

  const [labelerData, setLabelerData] = useState([]);
  const [manufacturersData, setManufacturersData] = useState([]);
  const [isFilterNDCs, setIsFilterNDCs] = useState(false);
  const [isDetailFilter, setIsDetailFilter] = useState(
    pageFor === 'detailFilter'
  );
  const [resetNDCsFilter, setResetNDCsFilter] = useState(false);
  const [ndcInputError, setNdcInputError] = useState(false);
  const [isFilterRightNDCs, setIsFilterRightNDCs] = useState(false);
  const [resetRightNDCsFilter, setResetRightNDCsFilter] = useState(false);

  const [totalLabelerCount, setTotalLabelerCount] = useState(0);
  const [totalManufacturerCount, setTotalManufacturerCount] = useState(0);
  const [totalNDCsLeftCount, setTotalNDCsLeftCount] = useState(0);
  const [totalNDCsRightCount, setTotalNDCsRightCount] = useState(0);

  const getNDCsTableList =
    pageFor === 'detailFilter' ? getNDCsModalTableList : getNDCsTableListRedux;
  const getNDCsList =
    pageFor === 'detailFilter' ? getNDCsModalList : getNDCsSearchList;
  // This run when state value changed and save in redux
  const setStateChange = (val) => {
    dispatch(
      setExNDCsExtraState({
        ...extraState,
        ...val,
      })
    );
  };

  const fetchLabelerList = useCallback(() => {
    setLoading(false);
    if (
      getLabelerList &&
      getSearchValue.chooseBy === 'NDC' &&
      getSearchValue.selectBy === 'Labeler'
    ) {
      setErrorMessages({
        ...errorMessages,
        serachPage: [],
      });
      if (
        getLabelerList.status === '001' &&
        getLabelerList.message === 'SUCESS'
      ) {
        setLabelerData(
          getLabelerList.data || getLabelerList.excludedNdcVOList || []
        );
      } else {
        setLabelerData([]);
      }
    }
  }, [getLabelerList]);

  React.useEffect(() => {
    setLoading(true);
    fetchLabelerList();
  }, [getLabelerList]);

  const fetchManufacturerList = useCallback(() => {
    setLoading(false);
    if (
      getManufacturerList &&
      getSearchValue.chooseBy === 'Labeler' &&
      !getSearchValue.allManufacturers
    ) {
      setErrorMessages({
        ...errorMessages,
        serachPage: [],
      });
      if (
        getManufacturerList.status === '001' &&
        getManufacturerList.message === 'SUCESS'
      ) {
        setManufacturersData(getManufacturerList.data || []);
      } else {
        setManufacturersData([]);
      }
    }
  }, [getManufacturerList]);

  React.useEffect(() => {
    setLoading(true);
    fetchManufacturerList();
  }, [getManufacturerList]);

  const mngNDCsList = (selection, list) => {
    let newList = [];
    if (!_.isEmpty(list)) {
      newList = _.map(list, (val, ind) => {
        const min = 10000;
        const max = 20000;
        const ranNum = Math.floor(Math.random() * (max - min + 1) + min);
        const ndc =
          selection === 'Existing Rows'
            ? val.ndc
            : `${val.labelerCode}-${val.productCode}-${val.packageSize}`;
        val.excludedNdcSeqNum = val.excludedNdcSeqNum || null;
        const ndc1 = _.replace(ndc, '-', '');
        val.listIndex = `${ndc1}${ranNum}${ind}`;
        val.ndc = ndc;
        val.ndcName =
          selection === 'Existing Rows' ? val.ndcName : val.drugName;
        val.startQtr =
          val.startQtr && !_.isEmpty(val.startQtr) ? val.startQtr : null;
        val.endQtr = val.endQtr && !_.isEmpty(val.endQtr) ? val.endQtr : null;
        val.oldStartQtr =
          val.startQtr && !_.isEmpty(val.startQtr) ? val.startQtr : null;
        val.oldEndQtr =
          val.endQtr && !_.isEmpty(val.endQtr) ? val.endQtr : null;
        val.excludedNdcStatusCd =
          selection === 'Existing Rows'
            ? _.capitalize(val.excludedNdcStatusCd)
            : 'Valid';
        return val;
      });
    }
    return newList;
  };

  const setNdcListForAll = (lNdc, rNdc) => {
    if (pageFor === 'detailFilter') {
      setIsDetailFilter(false);
      dispatch(
        excludedNDCsModalSearchTableList({
          ndcsLeft: isDetailFilter ? [] : lNdc,
          ndcsRight: isDetailFilter ? [] : rNdc,
        })
      );
    } else {
      setNDCsTableListAction({
        ndcsLeft: lNdc,
        ndcsRight: rNdc,
      });
    }
  };

  const fetchNDCs = useCallback(() => {
    let ndcList = [];
    setLoading(false);
    let selectionType = getSearchValue.selection;
    if (viewFilter && !_.isEmpty(viewFilter)) {
      selectionType = 'Any Rows';
    }
    if (getNDCsList && getSearchValue.chooseBy === 'NDC') {
      if (getNDCsList.message === 'SUCESS' && getNDCsList.status === '001') {
        ndcList = getNDCsList.data || getNDCsList.excludedNdcVOList || [];
        ndcList = _.cloneDeep(ndcList);
        ndcList = mngNDCsList(selectionType, ndcList);
        if (_.isEmpty(ndcList)) {
          let errMsg = NDC_NOT_FOUND;
          if (getSearchValue.selection !== 'Existing Rows') {
            errMsg =
              getSearchValue.selectBy === 'Name'
                ? ERR_NDC_NAME
                : getSearchValue.selectBy === 'NDC'
                ? ERR_NDC_NDC
                : NDC_NOT_FOUND;
          } else {
            errMsg =
              getSearchValue.selectBy === 'NDC'
                ? NDC_NOT_FOUND
                : NDC_NOT_FOUND_STC;
          }
          setErrorMessages({
            ...errorMessages,
            serachPage: [errMsg],
          });
        } else {
          setErrorMessages({
            ...errorMessages,
            serachPage: [],
          });
        }
      } else {
        setErrorMessages({
          ...errorMessages,
          serachPage: [NDC_NOT_FOUND],
        });
      }
    } else {
      setErrorMessages({
        ...errorMessages,
        serachPage: [],
      });
    }
    let ndcsRightList = getNDCsTableList?.ndcsRight;
    if (
      getSearchValue.chooseBy === 'NDC' &&
      getSearchValue.selectBy === 'NDC' &&
      !_.isEmpty(ndcList)
    ) {
      const checkDuplicate = !_.isEmpty(ndcsRightList)
        ? _.filter(ndcsRightList, (l) => l.ndc === ndcList[0].ndc)
        : [];
      if (_.isEmpty(checkDuplicate)) {
        ndcsRightList = [...ndcsRightList, ...ndcList];
        // setFilterValueTableAction({
        //   ndcsFilter: null,
        // });
      } else {
        setErrorMessages({
          ...errorMessages,
          serachPage: [NDC_ALREADY_FOR_STC_NOT],
        });
      }
    }
    const uniqueSortBy =
      selectionType === 'Existing Rows' ? 'excludedNdcSeqNum' : 'drugSeqNum';
    ndcList = !_.isEmpty(ndcList)
      ? _.orderBy(_.uniqBy(ndcList, uniqueSortBy), [uniqueSortBy], ['asc'])
      : [];
    ndcsRightList = !_.isEmpty(ndcsRightList)
      ? _.orderBy(ndcsRightList, [uniqueSortBy], ['asc'])
      : [];
    ndcList = !_.isEmpty(ndcList)
      ? _.filter(ndcList, (l) => l.ndc && !l.ndc.includes('null'))
      : [];
    // if (clearNDCLeft) {
    //   ndcList = [];
    //   setStateChange({ clearNDCLeft: false });
    // }
    setNdcListForAll(ndcList, ndcsRightList);
  }, [getNDCsList]);

  React.useEffect(() => {
    fetchNDCs();
  }, [getNDCsList]);

  const callLabelerListFetch = useCallback(() => {
    setLoading(false);
    let pass = true;
    if (getSearchValue.selection === 'Existing Rows') {
      pass = !!(
        getSearchValue.rebateProgram !== '-1' &&
        !_.isNull(getSearchValue.rebateProgram)
      );
    }
    if (pass && getSearchValue.rebateProgram) {
      let selectionType = getSearchValue.selection;
      if (viewFilter && !_.isEmpty(viewFilter)) {
        selectionType = 'Any Rows';
      }
      if (callLebelerAPI) {
        setLoading(true);
        setStateChange({ callLebelerAPI: false });
        fetchAllLabelerList({
          selection: selectionType,
          rebateProgramControl: getSearchValue.rebateProgram,
        });
      }
    } else {
      setLoading(false);
      setErrorMessages({
        ...errorMessages,
        serachPage: [REBATE_SELECT],
      });
    }
  }, [getSearchValue, callLebelerAPI]);

  React.useEffect(() => {
    setLoading(false);
    setErrorMessages({
      ...errorMessages,
      serachPage: [],
    });
    if (
      getSearchValue.chooseBy === 'NDC' &&
      getSearchValue.selectBy === 'Labeler'
    ) {
      setLoading(true);
      setManufacturersData([]);
      callLabelerListFetch();
    }
    if (
      getSearchValue.chooseBy === 'Labeler' &&
      !getSearchValue.allManufacturers &&
      getSearchValue.rebateProgram
    ) {
      setLoading(true);
      setLabelerData([]);
      fetchAllManufacturerList({
        showAllInd: true,
        rebateProgramControl: getSearchValue.rebateProgram,
      });
    }
  }, [filterValue]);

  const onSelectLabelerAndManufacturer = async (field, value) => {
    if (field === 'labeler') {
      let pass = true;
      if (getSearchValue.selection === 'Existing Rows') {
        pass = !!(
          getSearchValue.rebateProgram !== '-1' &&
          !_.isNull(getSearchValue.rebateProgram)
        );
      }
      if (pass && getSearchValue.rebateProgram) {
        setLoading(true);
        let selectionType = getSearchValue.selection;
        if (viewFilter && !_.isEmpty(viewFilter)) {
          selectionType = 'Any Rows';
        }
        let existingLabelerList = [];
        const payload = {
          pageFor: pageFor,
          labelerCode: value?.labelerCode,
          selection: selectionType,
          rebateProgramControl: getSearchValue.rebateProgram,
          page: 1,
          pageSize: 1,
        };
        if (getSearchValue.selection !== 'Existing Rows') {
          existingLabelerList = await getExistingLabelerList(
            payload,
            'labeler'
          );
        }
        searchNDCsByLabeler(payload, existingLabelerList);
        setFilterValueTableAction({
          ...getSearchValueTable,
          [field]: value,
        });
        setErrorMessages({
          ...errorMessages,
          serachPage: [],
        });
      } else {
        setErrorMessages({
          ...errorMessages,
          serachPage: [REBATE_SELECT],
        });
      }
    }
    if (field === 'manufacturer') {
      setFilterValueTableAction({
        ...getSearchValueTable,
        [field]: [value],
      });
    }
  };

  const onNDCsFilter = async () => {
    if (getSearchValueTable?.nameFilter) {
      let pass = true;
      if (getSearchValue.selection === 'Existing Rows') {
        pass = !!(
          getSearchValue.rebateProgram !== '-1' &&
          !_.isNull(getSearchValue.rebateProgram)
        );
      }
      if (pass && getSearchValue.rebateProgram) {
        setLoading(true);
        let selectionType = getSearchValue.selection;
        if (viewFilter && !_.isEmpty(viewFilter)) {
          selectionType = 'Any Rows';
        }
        let existingLabelerList = [];
        const payload = {
          pageFor: pageFor,
          searchBy: 'drugName',
          inputValue: getSearchValueTable?.nameFilter,
          selection: selectionType,
          rebateProgramControl: getSearchValue.rebateProgram,
          page: 0,
          pageSize: 1000,
        };
        if (getSearchValue.selection !== 'Existing Rows') {
          existingLabelerList = await getExistingLabelerList(
            payload,
            'drugName'
          );
        }
        searchNDCsByNameOrNdcs(payload, existingLabelerList);
      } else {
        setLoading(false);
        setErrorMessages({
          ...errorMessages,
          serachPage: [REBATE_SELECT],
        });
      }
    } else {
      setLoading(false);
      setErrorMessages({
        ...errorMessages,
        serachPage: ['Please Enter a valid search value.'],
      });
    }
  };

  const onSelectAction = (field, value) => {
    const request = { ...getSearchValueTable };
    if (field === 'ndcsLeft' || field === 'ndcsRight') {
      request[field] = value;
    } else {
      request[field] = value;
      request.ndcsLeft = [];
      request.ndcsRight = [];
    }
    setFilterValueTableAction(request);
  };

  const fetchNDCsAndMove = async (fType, e) => {
    const seVal = getSearchValueTable.ndcsFilter;
    const regexP = /^[\^A-Za-z0-9]{5}\-[\^A-Za-z0-9]{4}\-[\^A-Za-z0-9]{2}$/;
    const check = seVal && onChangeNDCsValue('check', seVal);
    if (!_.isEmpty(seVal) && !ndcInputError) {
      setErrorMessages({
        ...errorMessages,
        serachPage: [],
      });
      setLoading(true);
      if (check) {
        setStateChange({ ndcInputErr: false });
        // setNdcInputError(false);
        let pass = true;
        if (getSearchValue.selection === 'Existing Rows') {
          pass = !!(
            getSearchValue.rebateProgram !== '-1' &&
            !_.isNull(getSearchValue.rebateProgram)
          );
        }

        if (pass && getSearchValue.rebateProgram) {
          let selectionType = getSearchValue.selection;
          if (viewFilter && !_.isEmpty(viewFilter)) {
            selectionType = 'Any Rows';
          }
          let existingLabelerList = [];
          const payload = {
            pageFor: pageFor,
            searchBy: 'ndc',
            inputValue: getSearchValueTable.ndcsFilter,
            selection: selectionType,
            rebateProgramControl: getSearchValue.rebateProgram,
            page: 1,
            pageSize: 1,
          };
          if (getSearchValue.selection !== 'Existing Rows') {
            existingLabelerList = await getExistingLabelerList(payload, 'ndc');
          }
          searchNDCsByNameOrNdcs(payload, existingLabelerList);
        } else {
          setLoading(false);
          setErrorMessages({
            ...errorMessages,
            serachPage: [REBATE_SELECT],
          });
        }
      } else {
        setLoading(false);
        setStateChange({ ndcInputErr: true });
        // setNdcInputError(true);
        setErrorMessages({
          ...errorMessages,
          serachPage: [NDC_CODE_FOR_STC_NOT],
        });
      }
    } else {
      setLoading(false);
      setErrorMessages({
        ...errorMessages,
        serachPage: [NDC_ATLEAST_SELECT_ONE],
      });
    }
  };

  const onChangeNDCsValue = (fType, e) => {
    const regexP = /^[\^A-Za-z0-9]{5}[\^A-Za-z0-9]{4}[\^A-Za-z0-9]{2}$/;
    const regexP1 = /^[\^A-Za-z0-9]{5}\-[\^A-Za-z0-9]{4}\-[\^A-Za-z0-9]{2}$/;
    if (fType === 'onChange') {
      let val = e;
      if (val.length > 4) {
        val = val ? (val.length > 0 ? _.replace(val, '-', '') : val) : val;
        let splitVal = _.values(val);
        splitVal = _.filter(splitVal, (l) => l !== '-');
        const mapVal = [];
        _.map(splitVal, (v, i) => {
          if (i === 5 || i === 9) {
            mapVal.push('-');
            mapVal.push(v);
          } else {
            mapVal.push(v);
          }
        });
        const joinVal = _.join(mapVal, '');
        val = joinVal;
      }
      setFilterValueTableAction({
        ...getSearchValueTable,
        ndcsLeft: [],
        ndcsRight: [],
        nameFilter: null,
        ndcsFilter: val,
      });
    }
    if (fType !== 'onChange') {
      const err = !_.isEmpty(errorMessages)
        ? _.filter(errorMessages, (l) => l !== NDC_CODE_FOR_STC_NOT && !l)
        : [];
      setErrorMessages({
        ...errorMessages,
        serachPage: err,
      });
    }
    let errPass = false;
    if (fType === 'onBlur') {
      if (e.length < 1) {
        setStateChange({ ndcInputErr: false });
      } else if (regexP.test(e) || regexP1.test(e)) {
        setStateChange({ ndcInputErr: false });
        // setNdcInputError(false);
      } else {
        setErrorMessages({
          ...errorMessages,
          serachPage: [NDC_CODE_FOR_STC_NOT],
        });
        setStateChange({ ndcInputErr: true });
        // setNdcInputError(true);
      }
    } else if (e.length === 11 && regexP.test(e)) {
      errPass = true;
      // setStateChange({ ndcInputErr: false });
      // setNdcInputError(false);
    } else if (e.length === 13 && regexP1.test(e)) {
      errPass = true;
      // setStateChange({ ndcInputErr: false });
      // setNdcInputError(false);
    } else {
      errPass = false;
      const le = _.includes(e, '-') ? 13 : 11;
      if (e.length === le) {
        setErrorMessages({
          ...errorMessages,
          serachPage: [NDC_CODE_FOR_STC_NOT],
        });
        setStateChange({ ndcInputErr: true });
        // setNdcInputError(true);
        // } else {
        //   setStateChange({ ndcInputErr: false });
        //   setNdcInputError(false);
      }
    }
    return errPass;
  };

  const actionNDCsMove = useCallback(
    (moveFrom, rows) => {
      let leftList = [];
      let rightList = [];
      setLoading(true);
      if (moveFrom === 'AllLeftToRight') {
        if (!_.isEmpty(getNDCsTableList?.ndcsLeft)) {
          leftList = getNDCsTableList?.ndcsLeft;
          // rightList = getNDCsTableList?.ndcsLeft;
          const ndcLeftData = _.cloneDeep(getNDCsTableList?.ndcsLeft);
          const ndcRightData = _.cloneDeep(getNDCsTableList?.ndcsRight);

          const arrayAlready = [];
          const differentNDC = [];
          ndcRightData?.length > 0 &&
            ndcRightData.forEach((element) => {
              if (ndcLeftData?.length > 0) {
                if (
                  ndcLeftData.filter((el) => el.ndc == element.ndc)?.length > 0
                ) {
                  arrayAlready.push(element);
                } else {
                  differentNDC.push(element);
                }
              }
            });

          if (arrayAlready?.length > 0) {
            rightList = ndcLeftData;
          } else {
            rightList = ndcLeftData;
          }

          rightList = [...differentNDC, ...rightList];
          // rightList = _.concat(
          //   getNDCsTableList?.ndcsLeft,
          //   getNDCsTableList?.ndcsRight
          // );
          setErrorMessages({
            ...errorMessages,
            serachPage: [],
          });
        } else {
          leftList = getNDCsTableList?.ndcsLeft;
          rightList = getNDCsTableList?.ndcsRight;
          setErrorMessages({
            ...errorMessages,
            serachPage: [NDC_ATLEAST_SELECT_ONE],
          });
        }
      }
      if (moveFrom === 'AllRightToLeft') {
        leftList = getNDCsTableList?.ndcsLeft;
        rightList = [];
        setErrorMessages({
          ...errorMessages,
          serachPage: [NDC_ATLEAST_SELECT_ONE],
        });
      }
      if (moveFrom === 'leftToRight') {
        leftList = getNDCsTableList?.ndcsLeft;
        rightList = getNDCsTableList?.ndcsRight;
        if (
          !_.isEmpty(getNDCsTableList?.ndcsLeft) &&
          !_.isEmpty(getSearchValueTable[rows])
        ) {
          let checkNDCs = [];
          if (!_.isEmpty(getNDCsTableList?.ndcsRight)) {
            checkNDCs = _.filter(
              getNDCsTableList?.ndcsRight,
              (l) => l.ndc === getSearchValueTable[rows].ndc
            );
          }
          if (!_.isEmpty(checkNDCs)) {
            setErrorMessages({
              ...errorMessages,
              serachPage: [NDC_ALREADY_FOR_STC_NOT],
            });
          } else {
            // setOnGridReadyLeftNDC(true);
            setErrorMessages({
              ...errorMessages,
              serachPage: [],
            });
            rightList = [
              ...getNDCsTableList?.ndcsRight,
              getSearchValueTable[rows],
            ];

            setFilterValueTableAction({
              ...getSearchValueTable,
              [rows]: [],
            });
          }
        } else {
          setErrorMessages({
            ...errorMessages,
            serachPage: [NDC_ATLEAST_SELECT_ONE],
          });
        }
      }
      if (moveFrom === 'rightToLeft') {
        if (
          !_.isEmpty(getNDCsTableList?.ndcsRight) &&
          !_.isEmpty(getSearchValueTable[rows])
        ) {
          leftList = [...getNDCsTableList?.ndcsLeft];
          rightList = _.filter(
            getNDCsTableList?.ndcsRight,
            (l) => !_.isEqual(getSearchValueTable[rows].listIndex, l.listIndex)
          );
          setErrorMessages({
            ...errorMessages,
            serachPage: [],
          });
          setFilterValueTableAction({
            ...getSearchValueTable,
            [rows]: [],
          });
        } else {
          leftList = getNDCsTableList?.ndcsLeft;
          rightList = getNDCsTableList?.ndcsRight;
          setErrorMessages({
            ...errorMessages,
            serachPage: [NDC_ATLEAST_SELECT_ONE],
          });
        }
      }
      let selectionType = getSearchValue.selection;
      if (viewFilter && !_.isEmpty(viewFilter)) {
        selectionType = 'Any Rows';
      }
      const uniqueSortBy =
        selectionType === 'Existing Rows' ? 'excludedNdcSeqNum' : 'drugSeqNum';
      leftList = !_.isEmpty(leftList)
        ? _.orderBy(_.uniqBy(leftList, uniqueSortBy), [uniqueSortBy], ['asc'])
        : [];
      rightList = !_.isEmpty(rightList)
        ? _.orderBy(rightList, [uniqueSortBy], ['asc'])
        : [];

      setNdcListForAll(leftList, rightList);
      setLoading(false);
    },
    [getNDCsTableList, getSearchValueTable, errorMessages]
  );

  const viewExcludedNDCsDetail = async () => {
    let viewPage = false;
    const stateValue = {
      ...getSearchValueTable,
      listFor: null,
      list: [],
    };
    if (
      getSearchValue.rebateProgram !== '-1' &&
      !_.isNull(getSearchValue.rebateProgram)
    ) {
      if (getSearchValue.chooseBy === 'Labeler') {
        stateValue.listFor = 'Labeler';
        stateValue.manufacturers = getSearchValueTable?.manufacturer;
        stateValue.list = [];
        if (getSearchValue.allManufacturers) {
          viewPage = true;
          stateValue.list = [];
        } else if (
          _.isEmpty(getSearchValueTable?.manufacturer) &&
          !getSearchValue.allManufacturers
        ) {
          setErrorMessages({
            ...errorMessages,
            serachPage: [ERRORMESSAGE_MFR_NOT_EMPTY],
          });
        } else {
          viewPage = true;
        }
      } else {
        stateValue.listFor = 'ndcList';
        stateValue.list = getNDCsTableList?.ndcsRight;
        if (_.isEmpty(getNDCsTableList?.ndcsRight)) {
          setErrorMessages({
            ...errorMessages,
            serachPage: [NDC_ATLEAST_SELECT_ONE],
          });
        } else {
       
          if (
            getSearchValue.selection === 'Existing Rows' &&
            getSearchValue.chooseBy === 'NDC' &&
            getSearchValue.selectBy === 'NDC' &&
            (_.isEmpty(getOriginalExistingNDCList) || !getOriginalExistingNDCList)
          ) {
            setErrorMessages({
              ...errorMessages,
              serachPage: [NDC_NOT_FOUND],
            });
            viewPage = false;
          } else {
            viewPage = true;
          }
        }
      }
    } else {
      setErrorMessages({
        ...errorMessages,
        serachPage: [REBATE_SELECT],
      });
    }
    if (viewPage) {
      dispatch(saveExcludedNDCsDetailList({ orgList: [], updatedList: [] }));
      setLoading(true);
      let { detailPage } = errorMessages;
      let { detailTablePage } = errorMessages;
      if (window.location.pathname === '/excludedNDCs') {
        detailPage = [];
        detailTablePage = [];
      }
      setErrorMessages({
        ...errorMessages,
        serachPage: [],
        detailPage: detailPage,
        detailTablePage: detailTablePage,
      });
      stateValue.ndcsRight = [];
      const tempObj = [];
      if (stateValue.list?.length > 0) {
        stateValue.list.forEach((item) => {
          const objList = getOriginalExistingNDCList?.filter((x) => {
            return x.drugSeqNum === item.drugSeqNum;
          });
          if (objList?.length > 0) {
            objList.forEach((prop) => {
              tempObj.push(prop);
            });
          } else {
            tempObj.push(item);
          }
        });
      }
      let cloneList = _.cloneDeep(tempObj);
      cloneList = _.map(cloneList, (item) => {
        const val = _.cloneDeep(item);
        const listIndex = getRandomNumberByInput(1)[0];
        val.listIndex = listIndex;
        val.lastUpdateDt = val?.lastUpdateDt || null;
        val.excludedNdcSeqNum = val?.excludedNdcSeqNum || null;
        val.ndcName = val?.ndcName ? val?.ndcName : val?.drugName;
        val.ndc = val?.ndc
          ? val?.ndc
          : `${val?.labelerCode}-${val?.productCode}-${val?.packageSize}`;
        val.endQtr =
          val?.endQtr === '99994' || val?.endQtr === '4Q9999'
            ? ''
            : val?.endQtr;
        return val;
      });
      dispatch(
        saveExcludedNDCsDetailList({
          orgList: cloneList,
          updatedList: cloneList,
        })
      );
      setStateChange({ refExNDCList: true });
      setFilterValueTableAction(stateValue);
      // dispatch(updateFetchedNDCsValue([]));
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/excludedNDCsDetail',
        value: 'Excluded NDCs Detail',
        isRefresh: true,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      props.history.push({
        pathname: '/excludedNDCsDetail',
      });
    }
  };

  const changeResetNDCsFilter = (tableName) => {
    if (tableName === 'ndcLeft') {
      setResetNDCsFilter(true);
      setIsFilterNDCs(false);
    }
    if (tableName === 'ndcRight') {
      setResetRightNDCsFilter(true);
      setIsFilterRightNDCs(false);
    }
  };
  

  const onGridReadyLabeler = (params) => {
   requestAnimationFrame(() => {
      if (!getSearchValue?.selectRow) {
        params.api.forEachNode(
          // eslint-disable-next-line eqeqeq
          (node) => node?.rowIndex == 0 && node?.setSelected(true)
        );
        const selectedRowNodes = params.api?.getSelectedNodes();
        onSelectLabelerAndManufacturer('labeler', selectedRowNodes[0]?.data);
      } else {
        params.api.forEachNode(
          (node) =>
            node?.data?.labelerCode == getSearchValue?.selectRow?.labelerCode &&
            node?.setSelected(true)
        );
        onSelectLabelerAndManufacturer('labeler', getSearchValue?.selectRow);
      }
    });
  };
  return (
    <div data-testid="excludedNDCs-search-list-component">
      {!props.fullScreenViewForNDCLeft &&
      !props.fullScreenViewForNDCRight &&
      (getSearchValue.chooseBy === 'NDC' ||
        !getSearchValue.allManufacturers) ? (
        getSearchValue.selectBy === 'Labeler' ||
        getSearchValue.chooseBy === 'Labeler' ? (
          <>
            <GridTableComponent
              onGridReady={
                getSearchValue.selectBy === 'Labeler'
                  ? onGridReadyLabeler
                  : null
              }
              data={
                getSearchValue.chooseBy === 'Labeler' &&
                !getSearchValue.allManufacturers
                  ? manufacturersData
                    ? _.orderBy(manufacturersData, ['labelerCode'], ['asc'])
                    : manufacturersData
                  : getSearchValue.selectBy === 'Labeler' &&
                    getSearchValue.chooseBy === 'NDC'
                  ? labelerData
                    ? _.orderBy(labelerData, ['labelerCode'], ['asc'])
                    : labelerData
                  : []
              }
              cellHead={
                getSearchValue.chooseBy === 'Labeler' &&
                !getSearchValue.allManufacturers
                  ? manufacturersTableHead
                  : getSearchValue.selectBy === 'Labeler' &&
                    getSearchValue.chooseBy === 'NDC'
                  ? labelerTableHead
                  : []
              }
              gridHeight={
                props.fullScreenView
                  ? '65vh'
                  : getSearchValue.chooseBy === 'Labeler'
                  ? 300
                  : 176
              }
              onSelect={(e) => {
                dispatch(
                  dispatchExcludedNDCsSearch({
                    ...getSearchValue,
                    selectRow: e.data,
                  })
                );

                onSelectLabelerAndManufacturer(
                  getSearchValue.chooseBy === 'Labeler'
                    ? 'manufacturer'
                    : 'labeler',
                  e.data
                );
              }}
              rowSelection={
                getSearchValue.chooseBy === 'Labeler' ? 'single' : 'single'
              }
              rowMultiSelectWithClick={
                getSearchValue.chooseBy === 'Labeler' ? false : false
              }
              tableHeader
              filterIcon
              childPopup
              historyIcon={false}
              actionIcon
              fullScreenIcon
              setFullScreenView={() =>
                props.setFullScreenView(
                  getSearchValue.chooseBy === 'Labeler' &&
                    !getSearchValue.allManufacturers
                    ? 'Manufacturer List'
                    : getSearchValue.selectBy === 'Labeler' &&
                      getSearchValue.chooseBy === 'NDC'
                    ? 'Labeler'
                    : null
                )
              }
              fullScreenView={props.fullScreenView}
              fullScreenViewTable={props.fullScreenViewTable}
              fileName={
                getSearchValue.chooseBy === 'Labeler' &&
                !getSearchValue.allManufacturers
                  ? 'Manufacturer'
                  : getSearchValue.selectBy === 'Labeler' &&
                    getSearchValue.chooseBy === 'NDC'
                  ? 'Labeler'
                  : null
              }
              tableName={
                getSearchValue.chooseBy === 'Labeler' &&
                !getSearchValue.allManufacturers
                  ? 'manufacturer'
                  : getSearchValue.selectBy === 'Labeler' &&
                    getSearchValue.chooseBy === 'NDC'
                  ? 'labeler'
                  : null
              }
              setTotalResultCount={(e) =>
                getSearchValue.chooseBy === 'Labeler' &&
                !getSearchValue.allManufacturers
                  ? setTotalManufacturerCount(e)
                  : getSearchValue.selectBy === 'Labeler' &&
                    getSearchValue.chooseBy === 'NDC'
                  ? setTotalLabelerCount(e)
                  : null
              }
              data-testid="labeler-manufacturer-table-componenet"
            />
            <p className="total-results" tabIndex="0">
              Total Results:
              <b>
                {getSearchValue.chooseBy === 'Labeler' &&
                !getSearchValue.allManufacturers
                  ? totalManufacturerCount?.toLocaleString('en-US')
                  : getSearchValue.selectBy === 'Labeler' &&
                    getSearchValue.chooseBy === 'NDC'
                  ? totalLabelerCount?.toLocaleString('en-US')
                  : 0}
              </b>
            </p>
          </>
        ) : null
      ) : null}

      {!props.fullScreenView && (
        <>
          {!props.fullScreenViewForNDCLeft &&
            !props.fullScreenViewForNDCRight &&
            !props.tableView &&
            props.tableView !== 'ExcludedNDCsDetail' && (
              <div
                className={clsx(
                  'tab-header',
                  'display-inline-flex',
                  'FRR-custom-table'
                )}
              >
                {getSearchValue.chooseBy === 'NDC' &&
                getSearchValue.selectBy === 'Name' ? (
                  <div className="btn-wrapperExcud" >
                    <Box 
                      sx={{display: 'flex', alignItems: 'left', justifyContent: 'flex-end', gap: 1, }}
                    >
                      <TextField
                          id="standard-reason-code"
                          placeholder="Search..."
                          variant="outlined"
                          label="Search Field"
                          className="searchInput frr-display-hidden-label"
                          InputLabelProps={{ shrink: true }}
                          value={
                            !_.isArray(getSearchValueTable)
                              ? getSearchValueTable?.nameFilter || ''
                              : ''
                          }
                          onChange={(e) =>
                            onSelectAction('nameFilter', e.target.value)
                          }
                          onKeyDown={(e) =>
                            onSelectAction('nameFilter', e.target.value)
                          }
                          inputProps={{ maxLength: 30 }}
                          data-testid="excludedNDCs-search-by-name"
                          sx={{ flex: '1', minWidth: 200 }}
                        /> 
                        <Button
                          variant="contained"
                          size="small"
                          className="btn-success btn-primary btn-excd"
                          onClick={(e) => onNDCsFilter()}
                          data-testid="excludedNDCs-search-by-name-search-btn"
                        >
                          <SVGComponent iconName="Icon-search" />{' '}Search
                        </Button>
                    </Box>
                  </div>
                ) : (
                  <div className="clearfix" />
                )}

                {!pageFor && (
                  <div className="float-right mt-2 hide-on-print btn-wrapper btn-view-for-ndc">
                    <div className="btn-wrapper">
                      <Button
                        className="btn btn-success btn-save btn btn-primary ml-1"
                        onClick={viewExcludedNDCsDetail}
                        data-testid="view-excluded-ndcs-btn"
                      >
                        <SVGComponent iconName="Icon-view" /> View Excluded NDCs
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            )}
          {getSearchValue.chooseBy === 'NDC' && (
            <div className="ndcsTableSection FRR-custom-table">
              <div
                className={clsx(
                  'ndcTable',
                  'ndcTableLeft',
                  props.fullScreenViewForNDCLeft ? 'w-100' : '',
                  props.fullScreenViewForNDCRight ? 'display-none-imp' : ''
                )}
              >
                <DisplayErrorMessages
                  errorMessages={
                    !_.isEmpty(searchPageErrMsg)
                      ? _.filter(
                          searchPageErrMsg,
                          (l) => l === NDC_ALREADY_FOR_STC_NOT
                        )
                      : []
                  }
                />
                {getSearchValue.selectBy === 'NDC' ? (
                  <div className="selectedByNDCs">
                    <div className="ndcLabel">
                      Enter NDC to be added <span className="mandatory">*</span>
                    </div>
                    <TextField
                      id="standard-reason-code"
                      placeholder="XXXXX-XXXX-XX"
                      variant="outlined"
                      className="searchInput ndc-input frr-display-hidden-label"
                      label="label"
                      value={getSearchValueTable?.ndcsFilter || ''}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (_.lte(val.length, 13)) {
                          onChangeNDCsValue('onChange', val);
                        }
                      }}
                      onBlur={(e) =>
                        onChangeNDCsValue('onBlur', e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') fetchNDCsAndMove();
                      }}
                      inputProps={{
                        maxLength: 15,
                        inputMode: 'numeric',
                        pattern: '[0-9]*',
                      }}
                      helperText={
                        ndcInputErr && (
                          <DisplayErrorMessages
                            errorMessages={[NDC_CODE_FOR_STC_NOT]}
                          />
                        )
                      }
                      // helperText={
                      //   ndcInputError && <div
                      //     className="danger-text"
                      //   >
                      //     {NDC_CODE_FOR_STC_NOT}
                      //   </div>
                      // }
                      data-testid="excludedNDCs-search-by-ndc"
                    />
                  </div>
                ) : (
                  <>
                    <GridTableComponent
                      tableName="ndcLeft"
                      data={
                        getNDCsTableList?.ndcsLeft?.length > 0
                          ? _.orderBy(
                              getNDCsTableList?.ndcsLeft,
                              ['ndc'],
                              ['asc']
                            )
                          : getNDCsTableList?.ndcsLeft
                      }
                      cellHead={NDCTableHead}
                      // gridHeight={250}
                      gridHeight={props.fullScreenViewForNDCLeft ? '65vh' : 250}
                      setFullScreenView={() =>
                        props.setFullScreenView('ndcLeftList')
                      }
                      onSelect={(e) => onSelectAction('ndcsLeft', e.data)}
                      rowSelection="single"
                      rowMultiSelectWithClick={false}
                      tableHeader
                      childPopup
                      filterIcon
                      historyIcon={false}
                      actionIcon
                      fullScreenIcon
                      resetNDCsFilter={resetNDCsFilter}
                      isFilterNDCs={isFilterNDCs}
                      setResetNDCsFilter={(val) => setResetNDCsFilter(val)}
                      setIsFilterNDCs={(val) => setIsFilterNDCs(val)}
                      fileName="Excluded-NDCs-Selected-Left"
                      fullScreenViewTable="Excluded-NDCs-Selected-Left"
                      fullScreenView={props.fullScreenViewForNDCLeft}
                      setTotalResultCount={setTotalNDCsLeftCount}
                      data-testid="excludedNDCs-list-left-table"
                    />
                    <p className="total-results" tabIndex="0">
                      Total Results:
                      <b>{totalNDCsLeftCount?.toLocaleString('en-US')}</b>
                    </p>
                  </>
                )}
              </div>
              <div
                className={clsx(
                  'ndcTableBtn2',
                  props.fullScreenViewForNDCLeft ||
                    props.fullScreenViewForNDCRight
                    ? 'display-none-imp'
                    : ''
                )}
              >
                {getSearchValue.selectBy === 'NDC' ? (
                  <Button
                    className="btn-primary"
                    aria-label="All data forward"
                    onClick={() => fetchNDCsAndMove()}
                    data-testid="excludedNDCs-move-left-to-right-list-btn"
                    tabIndex={0}
                  >
                    <i
                      className="fa fa-light fa-caret-right"
                      aria-hidden="true"
                    />
                    <span className="hide-elm">Right Arrow</span>
                  </Button>
                ) : (
                  <Button
                    className="btn-primary"
                    aria-label="Single data forward"
                    onClick={() => actionNDCsMove('leftToRight', 'ndcsLeft')}
                    data-testid="excludedNDCs-move-left-to-right-list-btn"
                    tabIndex={0}
                  >
                    <i
                      className="fa fa-light fa-caret-right"
                      aria-hidden="true"
                    />
                    <span className="hide-elm">Right Arrow</span>
                  </Button>
                )}
                {getSearchValue.selectBy !== 'NDC' && (
                  <Button
                    className="btn-primary"
                    aria-label="All data forward"
                    onClick={() => actionNDCsMove('AllLeftToRight', null)}
                    data-testid="excludedNDCs-move-left-to-right-all-list-btn"
                    tabIndex={0}
                  >
                    <i className="fa fa-light fa-forward" aria-hidden="true" />
                    <span className="hide-elm">Left Arrow</span>
                  </Button>
                )}
                {getSearchValue.selectBy !== 'NDC' && (
                  <Button
                    className="btn-primary"
                    aria-label="All data backward"
                    onClick={() => actionNDCsMove('AllRightToLeft', null)}
                    data-testid="excludedNDCs-move-right-to-left-all-list-btn"
                    tabIndex={0}
                  >
                    <i className="fa fa-light fa-backward" aria-hidden="true" />
                    <span className="hide-elm">Left Arrow</span>
                  </Button>
                )}
                <Button
                  className="btn-primary"
                  aria-label="Single data backward"
                  onClick={() => actionNDCsMove('rightToLeft', 'ndcsRight')}
                  data-testid="excludedNDCs-move-right-to-left-list-btn"
                  tabIndex={0}
                >
                  <i className="fa fa-light fa-caret-left" aria-hidden="true" />
                  <span className="hide-elm">ndcsLeft Arrow</span>
                </Button>
              </div>
              <div
                className={clsx(
                  'ndcTable',
                  'ndcTableRight',
                  props.fullScreenViewForNDCRight ? 'w-100' : '',
                  props.fullScreenViewForNDCLeft ? 'display-none-imp' : ''
                )}
              >
                <GridTableComponent
                  tableName="ndcRight"
                  data={
                    getNDCsTableList?.ndcsRight
                      ? _.orderBy(getNDCsTableList?.ndcsRight, ['ndc'], ['asc'])
                      : getNDCsTableList?.ndcsRight
                  }
                  cellHead={NDCTableHead}
                  gridHeight={props.fullScreenViewForNDCRight ? '65vh' : 250}
                  setFullScreenView={() =>
                    props.setFullScreenView('ndcRightList')
                  }
                  onSelect={(e) => onSelectAction('ndcsRight', e.data)}
                  rowSelection="single"
                  rowMultiSelectWithClick={false}
                  childPopup
                  tableHeader
                  filterIcon
                  historyIcon={false}
                  actionIcon
                  fullScreenIcon
                  fileName="Excluded-NDCs-Selected-Right"
                  fullScreenViewTable="Excluded-NDCs-Selected-Right"
                  fullScreenView={props.fullScreenViewForNDCRight}
                  setTotalResultCount={setTotalNDCsRightCount}
                  data-testid="excludedNDCs-list-right-table"
                  resetNDCsFilter={resetNDCsFilter}
                  resetRightNDCsFilter={resetRightNDCsFilter}
                  setResetRightNDCsFilter={(val) =>
                    setResetRightNDCsFilter(val)
                  }
                  setIsFilterRightNDCs={(val) => setIsFilterRightNDCs(val)}
                />
                <p className="total-results" tabIndex="0">
                  Total Results:
                  <b>{totalNDCsRightCount?.toLocaleString('en-US')}</b>
                </p>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
export default ExcludedNDCsListGrid;
